// AttributeComponent.js
import styles from "@/components/ui/cards/attributes/AttributeComponent.module.css";

const AttributeComponent = ({ attribute }) => {
  const parseValue = (value, unit) => {
    if (unit && unit !== "null") {
      return (
        <>
          <span className={styles.attributeValue}>{value}</span>
          <span className={styles.attributeUnit}>{` ${unit}`}</span>
        </>
      );
    } else if (value.includes(" ")) {
      const segments = value.split(" ");
      return segments.map((segment, index) => {
        const isValue = index % 2 === 0;
        return (
          <span
            key={index}
            className={isValue ? styles.attributeValue : styles.attributeUnit2}>
            {segment}
          </span>
        );
      });
    } else {
      return <span className={styles.attributeValue}>{value}</span>;
    }
  };

  return (
    <div className={styles.attribute}>
      <div className={styles.attributeData}>
        {parseValue(attribute.value, attribute.unit)}
      </div>
      <div className={styles.attributeName}>{attribute.attribute}</div>
    </div>
  );
};

export default AttributeComponent;
